import { definitions } from '@luxuryescapes/contract-trip'

import { extractEndDateTime, extractStartDateTime } from '.'

import { PublicFullTrip, PublicTripItem } from 'tripPlanner/types/publicTrip'
import { assertUnreachable, makeDate } from 'tripPlanner/utils'

export const publicTripItem = (
  item: definitions['publicTripItem'],
  tripId: string,
): PublicTripItem => {
  switch (item.type) {
    case 'EVENT':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }

    case 'EXPERIENCE':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'ACCOMMODATION':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        savedItemData: item.savedItemData,
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'RESTAURANT_BAR':
    case 'ATTRACTION':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'BUS':
    case 'FERRY':
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'THING_TO_DO':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'FLIGHT':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'CAR_RENTAL':
    case 'CRUISE':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'TOUR':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        savedItemData: item.savedItemData,
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'NOTE':
      let noteContent = item.notes
      if (item.link) {
        noteContent += `\n\n${item.link}`
      }

      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        notes: noteContent,
        isSectionHeader: !!item.isSectionHeader,
      }
    case 'HOTEL_BUNDLE':
      throw new Error('HOTEL_BUNDLE is not supported yet')
    default:
      return assertUnreachable(item)
  }
}

export const fullPublicTrip = (
  trip: definitions['fullPublicTrip'],
): PublicFullTrip => {
  const items = trip.items.map((i) => publicTripItem(i, trip.id))

  return {
    id: trip.id,
    name: trip.name,
    imageId: trip.imageId,
    items,
    startDate: trip.startDate ? makeDate(trip.startDate) : undefined,
    endDate: trip.endDate ? makeDate(trip.endDate) : undefined,
    startDay: trip.startDay,
    endDay: trip.endDay,
  }
}
